/** @module Enums */ /** typedoc */

export enum PaymentMethodEnum {
    CreditCard = 'CreditCard',
    SavedCreditCard = 'SavedCreditCard',
    PayPal = 'PayPal'
}
